const changeHtml = () => {
  const cookie_shop_code = Cookies.get('shop_code');
  let slide

  const removeHtml = (sex) => {
    slide = document.querySelectorAll(`[data-slide-mw=${sex}]`)
    Array.from(slide).forEach((value) => {
      value.remove()
    })
  } 

  if (cookie_shop_code == 'AOGL-LADIES') {
    removeHtml('men')
  } else if (cookie_shop_code == 'AOGL-MENS') {
    removeHtml('women')
  } else {
    removeHtml('women')
  }

  const dot = document.querySelectorAll('.top-glide .glide__slide')
  const btn = document.querySelectorAll('.slider__bullets .slider__bullet')

  if(dot.length == 1) {
    document.querySelector('.slider__bullets').remove()
  } else {
    for(let i = 0; i < btn.length - dot.length; i++) {
      document.querySelector('.slider__bullets .slider__bullet:last-of-type').remove()
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  changeHtml()
  const glide = new Glide('.glide', {
    type: 'carousel',
    startAt: '0',
    perView: 1,
    focusAt: 'center',
    hoverpause: false,
    gap: 0,
    autoplay: 5000,
    breakpoints: {
      768: {
        perView: 1,
        focusAt: 'center',
      },
    }
  });
  glide.mount();
})